import React, { useState, useEffect, useRef } from "react";
import { useReactToPrint } from 'react-to-print';
import {
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Grid,
  Typography,
  Collapse,
  Box,
  CssBaseline,
  Container,
  Card,
  CardContent,
  CardActions,
  IconButton,
  Alert,
  Chip,
  Divider,
  useMediaQuery
} from "@mui/material";
import {
  AttachMoney,
  LocalShipping,
  CheckCircle,
  Info,
  CalendarMonth,
  Payments,
  ExpandMore,
  ExpandLess
} from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import Layout from "./Layout";
import { format, isValid } from "date-fns";
import { enGB } from "date-fns/locale";
import { Switch, FormControlLabel } from '@mui/material';
import { startOfToday, startOfTomorrow, startOfDay, endOfDay } from "date-fns";
import { collection, query, where, getDocs, updateDoc, addDoc, Timestamp, runTransaction, doc, getDoc } from "firebase/firestore";
import { db,storage } from "./firebase"; // Update this path to your Firebase config
import { deleteObject, ref } from "firebase/storage";
import { useAppContext } from "./AppContext";
import BalanceReceipt from './components/BalanceReceipt'; // Import the receipt component
import Refund from './Refund';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import Snackbar from "@mui/material/Snackbar";
import ReleaseOrderDialog from "./components/ReleaseOrderDialog";


const ReleaseOrder = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [expandedOrderId, setExpandedOrderId] = useState(null);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [confirmOrderId, setConfirmOrderId] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [originalData,setOriginalData]=useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [balance, setBalance] = useState(0);
  const [deliveryFee, setDeliveryFee] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState('Cash');
  const [deliveryPaymentMethod, setDeliveryPaymentMethod] = useState('Cash');
  const today = startOfToday();
  const tomorrow = startOfTomorrow();
  const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };
  
  // Helper function to generate unique transaction IDs
  const generateTransactionId = (orderId, type, method = '') => {
    return `${orderId}-${type}-${method}-${Date.now()}`;
  };

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(addDays(today,6));
  const [isBalanceCollected, setIsBalanceCollected] = useState(false);
  const [isDeliveryPaid, setIsDeliveryPaid] = useState(false);
  const [orderCompleted,setOrderCompleted]=useState(false);
  const [showUncompletedOnly, setShowUncompletedOnly] = useState(false);
  const { shopId, userId, userName, isOnShift, t } = useAppContext();
  const [completeOrderLoading,setCompleteOrderLoading] = useState(false);
  const [isOffline, setIsOffline] = useState(false);
  const [splitPayments, setSplitPayments] = useState([
    { method: '', amount: '' }
  ]);
  const [balanceError,setBalanceError] = useState(false);
  const receiptRef = useRef();
  const [collectBalanceLoading, setCollectBalanceLoading] = useState(false);
  const [payDeliveryLoading, setPayDeliveryLoading] = useState(false);
  const [showRefundModal, setShowRefundModal] = useState(false);
  const [selectedOrderForRefund, setSelectedOrderForRefund] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [selectedCashier, setSelectedCashier] = useState(null); // Add state for selected cashier
  const [selectedOrderForDialog, setSelectedOrderForDialog] = useState(null);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const showTableView = !isMobile && !isTablet;


  const todayOrders = originalData.filter((order) => {
    if (searchQuery.length === 0) {
      const orderDate = new Date(order.fulfillmentTime);
      return orderDate >= startOfDay(today) && orderDate <= endOfDay(today);
    }
    return false; // Ensure a value is returned
  });

  const tomorrowOrders = originalData.filter((order) => {
    if (searchQuery.length === 0) {
      const orderDate = new Date(order.fulfillmentTime);
      return orderDate >= startOfDay(tomorrow) && orderDate <= endOfDay(tomorrow);
    }
    return false; // Ensure a value is returned
  });

  const todayOrderstoDeliver = originalData.filter((order) => {
    if (searchQuery.length === 0) {
      const orderDate = new Date(order.fulfillmentTime);
      return (
        orderDate >= startOfDay(today) &&
        orderDate <= endOfDay(today) &&
        order.fulfillmentMethod === "Delivery"
      );
    }
    return false; // Ensure a value is returned
  });
  

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOrderClick = (orderId) => {
    setExpandedOrderId(expandedOrderId === orderId ? null : orderId);
  };
  
  const handleActionClick = (action, order) => {
    if (!order) {
      return;
    }

    if (action === "complete") {
      setConfirmOrderId(order.id);
      setSelectedOrderForDialog(order);
      setBalance(Number(order.remainingBalance) || 0);
      setDeliveryFee(order.deliveryFeeAmount || 0);
      setConfirmationOpen(true);

      if (order.orderStatus === "Completed") {
        setOrderCompleted(true);
      }
      if (order.balanceStatus === "Paid") {
        setIsBalanceCollected(true);
        setBalance(0);
      }
      if (order.deliveryPaid) {
        setIsDeliveryPaid(true);
        setDeliveryFee(0);
      }
    } else if (action === "details") {
      handleOrderClick(order.id);
    }
  };
  

  const handleCompleteOrder = async () => {
  setCompleteOrderLoading(true);
  try {
    // Get direct reference using document ID
    const orderDocRef = doc(db, "orders", confirmOrderId);
    
    // First check if the order is already completed
    const orderDoc = await getDoc(orderDocRef);
    if (!orderDoc.exists()) {
      console.error("Order document not found");
      return;
    }
    
    const orderData = orderDoc.data();
    if (orderData.orderStatus === "Completed") {
      console.log("Order already marked as completed");
      setOrderCompleted(true);
      setSnackbarMessage(t('Order was already marked as completed'));
      setSnackbarSeverity("info");
      setSnackbarOpen(true);
      return;
    }
    
    // Create a JavaScript Date object for completion date
    const completionDate = new Date();
    
    // Generate a transaction ID for this completion
    const completionTransactionId = generateTransactionId(orderData.orderID, "order-completion");

    // Update the order status to complete
    await updateDoc(orderDocRef, {
      orderStatus: "Completed",
      completionDate: completionDate,
      balanceStatus: "Paid",
      completedBy: selectedCashier,
      completionTransactionId: completionTransactionId
    });

    // Check if the order has images to delete
    if (orderData.imageUrls && orderData.imageUrls.length > 0) {
      const deletePromises = orderData.imageUrls.map(async (imageUrl) => {
        const filePath = decodeURIComponent(imageUrl.split("/o/")[1].split("?")[0]);
        const fileRef = ref(storage, filePath);

        try {
          await deleteObject(fileRef);
          console.log(`Deleted image: ${imageUrl}`);
        } catch (error) {
          console.error(`Error deleting image: ${imageUrl}`, error);
        }
      });

      await Promise.all(deletePromises);
      console.log("All images deleted successfully.");
    }  

    // Update local state using document ID
    setOriginalData((prevOrders) =>
      prevOrders.map((order) =>
        order.id === confirmOrderId // Use document ID for comparison
          ? { 
              ...order, 
              orderStatus: "Completed", 
              completedBy: selectedCashier,
              completionDate: completionDate
            }
          : order
      )
    );
    
    setFilteredData((prevOrders) =>
      prevOrders.map((order) =>
        order.id === confirmOrderId // Use document ID for comparison
          ? { 
              ...order, 
              orderStatus: "Completed", 
              completedBy: selectedCashier,
              completionDate: completionDate
            }
          : order
      )
    );

    setConfirmationOpen(false);
    setConfirmOrderId(null);

  } catch (error) {
    console.error("Error updating order status: ", error);
  } finally {
    setCompleteOrderLoading(false);
    setConfirmationOpen(false);
    setConfirmOrderId(null);
    setOrderCompleted(false);
    setIsDeliveryPaid(false);
    setDeliveryFee(0);
    setIsBalanceCollected(false);
    setBalance(0);
    setSelectedCashier(null); 
  }
};

  const handleCollectBalance = async () => {
  if (collectBalanceLoading) return;
  setCollectBalanceLoading(true);
  setBalanceError(false);

  try {
    // Validate split payments
    if (!validateSplitPayments()) {
      setBalanceError(true);
      return;
    }
    
    // Get direct reference using document ID
    const orderDocRef = doc(db, "orders", confirmOrderId); // confirmOrderId now contains document ID
    
    // First check if balance is already marked as paid
    const orderDoc = await getDoc(orderDocRef);
    if (!orderDoc.exists()) {
      console.error("Order document not found");
      setSnackbarMessage(t('Order not found'));
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }
    
    const orderData = orderDoc.data();
    if (orderData.balanceStatus === "Paid") {
      console.log("Balance already marked as paid for this order");
      setIsBalanceCollected(true);
      setSnackbarMessage(t('Balance already collected for this order'));
      setSnackbarSeverity("info");
      setSnackbarOpen(true);
      return;
    }

    const description = `Outstanding Payment for Order #${orderData.orderID}`;

    // Save each split payment as a separate transaction
    for (const payment of splitPayments) {
      // Generate unique transaction ID for idempotency
      const transactionId = generateTransactionId(orderData.orderID, "balance-payment", payment.method);
      
      // Check if this transaction already exists
      const existingTransactionQuery = query(
        collection(db, "cashbook"),
        where("transactionId", "==", transactionId)
      );
      const existingSnapshot = await getDocs(existingTransactionQuery);
      
      // Only add if this exact transaction doesn't exist
      if (existingSnapshot.empty) {
        await addDoc(collection(db, "cashbook"), {
          transactionId: transactionId,
          amount: payment.amount,
          paymentMethod: payment.method,
          timestamp: Timestamp.now(),
          shopId: shopId,
          orderId: Number(orderData.orderID),
          orderDocumentId: confirmOrderId, // Add document ID reference
          description: description,
          transactionType: "income",
          userId: userId,
          userName: userName,
        });
      } else {
        console.log(`Transaction ${transactionId} already exists, skipping duplicate`);
        setSnackbarMessage(t('Avoided duplicate transaction entry'));
        setSnackbarSeverity("warning");
        setSnackbarOpen(true);
      }
    }

    console.log("Split payments successfully added!");
    setIsBalanceCollected(true);
    
    // Use transaction to ensure atomicity when updating the order
    await runTransaction(db, async (transaction) => {
      const orderDoc = await transaction.get(orderDocRef);
      
      if (!orderDoc.exists()) {
        throw new Error("Order document does not exist!");
      }
      
      const orderData = orderDoc.data();
      
      // Check again within the transaction if already paid
      if (orderData.balanceStatus === "Paid") {
        console.log("Balance already paid - caught in transaction");
        return;
      }
      
      // Update the balance status to paid
      transaction.update(orderDocRef, {
        balanceStatus: "Paid",
        balancePaidTimestamp: Timestamp.now()
      });
    });

    // Update local state using document ID
    setOriginalData((prevOrders) =>
      prevOrders.map((order) =>
        order.id === confirmOrderId // Use document ID for comparison
          ? { ...order, balanceStatus: "Paid" }
          : order
      )
    );
    
    setFilteredData((prevOrders) =>
      prevOrders.map((order) =>
        order.id === confirmOrderId // Use document ID for comparison
          ? { ...order, balanceStatus: "Paid" }
          : order
      )
    );
  } catch (error) {
    console.error("Error adding split payments: ", error);
  } finally {
    setCollectBalanceLoading(false);
  }
};

  const handlePayDelivery = async () => {
  if (payDeliveryLoading) return;
  setPayDeliveryLoading(true);

  try {
    // Get direct reference using document ID
    const orderDocRef = doc(db, "orders", confirmOrderId);
    
    // First check if delivery is already marked as paid
    const orderDoc = await getDoc(orderDocRef);
    if (!orderDoc.exists()) {
      console.error("Order document not found");
      setSnackbarMessage(t('Order not found'));
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }
    
    const orderData = orderDoc.data();
    if (orderData.deliveryPaid === true) {
      console.log("Delivery fee already marked as paid for this order");
      setIsDeliveryPaid(true);
      setSnackbarMessage(t('Delivery fee already paid for this order'));
      setSnackbarSeverity("info");
      setSnackbarOpen(true);
      return;
    }
    
    const description = `Refund Delivery Payment of Order #${orderData.orderID}`;
    
    // Generate unique transaction ID for idempotency
    const transactionId = generateTransactionId(orderData.orderID, "delivery-payment", deliveryPaymentMethod);
    
    // Check if this transaction already exists
    const existingTransactionQuery = query(
      collection(db, "cashbook"),
      where("transactionId", "==", transactionId)
    );
    const existingSnapshot = await getDocs(existingTransactionQuery);
    
    // Only add if this exact transaction doesn't exist
    if (existingSnapshot.empty) {
      await addDoc(collection(db, "cashbook"), {
        transactionId: transactionId,
        amount: Number(deliveryFee),
        paymentMethod: deliveryPaymentMethod,
        timestamp: Timestamp.now(),
        shopId: shopId,
        orderId: Number(orderData.orderID),
        orderDocumentId: confirmOrderId, // Add document ID reference
        description: description,
        transactionType: "refund",
        userId: userId,
        userName: userName,
      });
    } else {
      console.log(`Transaction ${transactionId} already exists, skipping duplicate`);
      setSnackbarMessage(t("Avoided duplicate delivery payment entry"));
      setSnackbarSeverity("warning");
      setSnackbarOpen(true);
    }

    console.log("Refund amount successfully added!");
    setIsDeliveryPaid(true);
    
    // Use transaction to ensure atomicity when updating the order
    await runTransaction(db, async (transaction) => {
      const orderDoc = await transaction.get(orderDocRef);
      
      if (!orderDoc.exists()) {
        throw new Error("Order document does not exist!");
      }
      
      const orderData = orderDoc.data();
      
      // Check again within the transaction if already paid
      if (orderData.deliveryPaid === true) {
        console.log("Delivery fee already paid - caught in transaction");
        return;
      }
      
      // Update the delivery paid status
      transaction.update(orderDocRef, {
        deliveryPaid: true,
        deliveryPaidTimestamp: Timestamp.now()
      });
    });

    // Update local state using document ID
    setOriginalData((prevOrders) =>
      prevOrders.map((order) =>
        order.id === confirmOrderId // Use document ID for comparison
          ? { ...order, deliveryPaid: true }
          : order
      )
    );
    
    setFilteredData((prevOrders) =>
      prevOrders.map((order) =>
        order.id === confirmOrderId // Use document ID for comparison
          ? { ...order, deliveryPaid: true }
          : order
      )
    );
  } catch (error) {
    console.error("Error adding refund: ", error);
  } finally {
    setPayDeliveryLoading(false);
  }
};

  const handleConfirmationClose = () => {
    setConfirmationOpen(false); // Close dialog first

    setTimeout(() => {
        setOrderCompleted(false);
        setConfirmOrderId(null);
        setSelectedOrderForDialog(null);
        setCompleteOrderLoading(false);
        setIsDeliveryPaid(false);
        setDeliveryFee(0);
        setIsBalanceCollected(false);
        setBalance(0);
        setBalanceError(false);
        setPaymentMethod("Cash");
        setSplitPayments([{ method: "", amount: 0 }]);
        setCollectBalanceLoading(false); // Reset loading state
        setPayDeliveryLoading(false);    // Reset loading state
        setSelectedCashier(null); // Reset selected cashier
    }, 300); // Small delay to prevent flashing
   
  };

  const getStatusChipProps = (status) => {
    switch (status) {
      case "Completed":
        return { color: "success", label: t("Completed") };
      case "Fulfilled":
        return { color: "info", label: t("Fulfilled") };
      case "Unfulfilled":
        return { color: "warning", label: t("Unfulfilled") };
      default:
        return { color: "default", label: status ? t(status) : t("Unknown") };
    }
  };

    // Check if orderDate is a Date object
                           
    const formatDate = (input) => {
      let date;
    
      // Check if it's a Firestore Timestamp with toDate method
      if (input instanceof Date) {
        date = input;
      } else if (input && typeof input.toDate === "function") {
        date = input.toDate();
      } else {
        return t("Invalid date");
      }
    
      return isValid(date) ? format(date, "dd-MM-yyyy hh:mm a") : t("Invalid date");
    };

  const formatToMyanmarCurrency = (number) => {
    const formattedNumber = new Intl.NumberFormat('my-MM').format(number);
    return `${formattedNumber}`;
  };

  const renderDeliveryPaymentType = ({ order }) => {
    if (order.deliveryFeeType === "Advance") {
      return (
        <>
          <Typography variant="body1">
            <Payments sx={{ marginRight: "5px", color: "gray" }} />
            <strong>{t("Delivery Charge Method")}</strong>: {t("Advance")}
          </Typography>
          <Typography variant="body1">
            <AttachMoney sx={{ marginRight: "5px", color: "gray" }} />
            <strong>{t("Delivery Charge")}</strong>: {order.deliveryFeeAmount} {t("MMK")}
          </Typography>
        </>
      );
    } else if (order.deliveryFeeType === "Collect") {
      return (
        <Typography variant="body1">
          <Payments sx={{ marginRight: "5px", color: "gray" }} />
          <strong>{t("Delivery Charge Method")}</strong>: {t("To Collect")}
        </Typography>
      );
    }
    return null;
  };

  const renderExpandedDetails = (order) => (
    <Box
      sx={{
        margin: 1,
        padding: 3,
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        backgroundColor: "background.paper",
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6} md={6}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #ccc",
              padding: 2,
              marginBottom: 2,
            }}
          >
            <AttachMoney sx={{ fontSize: 40, color: "#c62828", marginRight: 2 }} />
            <Box>
              <Typography variant="h6">
                {order.orderStatus === "Completed" ? t("Collected Balance") : t("Outstanding Balance")}
              </Typography>
              <Typography variant="h5">{formatToMyanmarCurrency(order.remainingBalance || 0)} {t("MMK")}</Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #ccc",
              padding: 2,
              marginBottom: 2,
            }}
          >
            <CalendarMonth sx={{ fontSize: 40, marginRight: 2, color: "#2196f3" }} />
            <Box>
              <Typography variant="h6">
                {order.orderStatus === "Completed" ? t("Collected Time") : t("Fulfillment Time")}
              </Typography>
              <Typography variant="h5">
                {order.orderStatus === "Completed"
                  ? (order.completionDate ? formatDate(order.completionDate) : "-")
                  : formatDate(order.fulfillmentTime)}
              </Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Table size="small" sx={{ mt: 2 }}>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography fontWeight="bold">{t("Item Name")}</Typography>
            </TableCell>
            <TableCell>
              <Typography fontWeight="bold">{t("Variant")}</Typography>
            </TableCell>
            <TableCell>
              <Typography fontWeight="bold">{t("Quantity")}</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {order.cartItems.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{item.name}</TableCell>
              <TableCell>{item.selectedVariant}</TableCell>
              <TableCell>{item.quantity}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Typography variant="subtitle1" sx={{ marginTop: 2 }}>
        <strong>{t("Inscription Text")}:</strong> {order.inscription}
      </Typography>
      {order.orderStatus === "Completed" && (
        <Typography variant="subtitle1" sx={{ marginTop: 0 }}>
          <strong>{t("Released By")}:</strong> {order.completedBy || "-"}
        </Typography>
      )}

      {order.deliveryAddress && (
        <Typography variant="body1" mt={3}>
          <LocalShipping sx={{ marginRight: "5px", color: "gray" }} />
          <strong>{t("Delivery Address")}</strong> {order.deliveryAddress}
        </Typography>
      )}

      <Box sx={{ mt: 2 }}>{renderDeliveryPaymentType({ order })}</Box>
    </Box>
  );

  useEffect(() => {
    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);

    // Add event listeners for online and offline events
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Check initial status
    setIsOffline(!navigator.onLine);

    // Clean up event listeners on component unmount
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Fetch orders from Firestore
  useEffect(() => {
    const fetchOrders = async () => {
      const ordersRef = collection(db, "orders");
      
      let q = query(
        ordersRef,
        where("shopId", "==", shopId)
      );
  
      // Add search conditions if searchQuery is not empty
      if (searchQuery.length > 0) {
        const isNumericQuery = !isNaN(searchQuery);
        if (isNumericQuery) {
                q = query(
                  ordersRef,
                  where("orderID", "==", searchQuery),
                  where("shopId", "==", shopId)
                );
              } else {
                q = query(
                  ordersRef,
                  where("inscription", ">=", searchQuery),
                  where("inscription", "<=", searchQuery + "\uf8ff"),
                  where("shopId", "==", shopId)
                );
              }
      } else {
        // When no search query, apply original date and status filters
        q = query(
          q,
          where("fulfillmentTime", ">=", startOfDay(fromDate)),
          where("fulfillmentTime", "<=", endOfDay(toDate)),
          where("orderStatus", "!=", "Canceled")
        );
      }
  
      // Add uncompleted orders filter if enabled
      if (showUncompletedOnly) {
        q = query(q, where("orderStatus", "in", ["Fulfilled", "Unfulfilled"]));
      }
  
      const querySnapshot = await getDocs(q);
      const orders = querySnapshot.docs.map(doc => ({ 
        ...doc.data(),
        id: doc.id,
        fulfillmentDate: doc.data().fulfillmentDate.toDate(),
        fulfillmentTime: doc.data().fulfillmentTime.toDate(),
      }));
  
      setFilteredData(orders);
      setOriginalData(orders);
    };
  
    fetchOrders();
  }, [fromDate, toDate, shopId, searchQuery, showUncompletedOnly]);

  const handleSplitPaymentMethodChange = (index, method) => {
    const newSplitPayments = [...splitPayments];
    newSplitPayments[index].method = method;
    setSplitPayments(newSplitPayments);
  };
  
  const handleSplitPaymentAmountChange = (index, amount) => {
    const newSplitPayments = [...splitPayments];
    newSplitPayments[index].amount = Number(amount);
    setSplitPayments(newSplitPayments);
  };
  
  const addSplitPayment = () => {
    if (splitPayments.length < 3) {
      setSplitPayments([...splitPayments, { method: '', amount: 0 }]);
    }
  };
  
  const removeSplitPayment = (index) => {
    if (splitPayments.length > 1) {
      const newSplitPayments = splitPayments.filter((_, i) => i !== index);
      setSplitPayments(newSplitPayments);
    }
  };
  
  const validateSplitPayments = () => {
    // Ensure total split payments match the balance
    const totalSplitAmount = splitPayments.reduce((sum, payment) => sum + payment.amount, 0);
    return Math.abs(totalSplitAmount - balance) < 0.01 && 
           splitPayments.every(payment => payment.method && payment.amount > 0);
  };

  const handlePrint = useReactToPrint({
    content: () => receiptRef.current,
  });
  
  const handleRefundClick = (orderId, documentId) => { // Add documentId parameter
  const order = filteredData.find(o => o.id === documentId); // Use document ID instead of orderID
  if (order.orderStatus === 'Unfulfilled') {
    setSelectedOrderForRefund(order);
    setShowRefundModal(true);
  } else {
    setSnackbarMessage(t("Cannot refund: Order must be in 'Unfulfilled' status"));
    setSnackbarSeverity("error");
    setSnackbarOpen(true);
  }
};
  
  const handleRefundClose = (success) => {
    setShowRefundModal(false);
    setSelectedOrderForRefund(null);
    if (success) {
      setSnackbarMessage(t('Refund processed successfully'));
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      // Refresh orders
      //fetchOrders();
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Layout>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container sx={{m:0}}>
      {isOffline && (
            <Alert severity="warning" sx={{ marginTop: '10px' }}>
              {t("You are offline. Some features may not be available.")}
            </Alert>
          )}
         {!isOnShift ? (
                <Alert severity="error" sx={{marginTop:'10px'}}>{t("You are not on shift. Please start your shift to proceed.")}</Alert>
              ) : (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
          <Typography variant="h4" sx={{ marginTop: 3, marginBottom: 2 }}>
            {t("Release Orders")}
          </Typography>
          <Box mt={3}>
            {/* Card Container */}
            <Grid
              container
              spacing={2}
              alignItems="center"
             
            >
              <Grid item xs={12} sm={4} md={4}>
                <Card variant="outlined" sx={{ padding: 2, textAlign: "left" }}>
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="flex-start"
                    spacing={3}
                  >
                    
                    <Grid item>
                      <Typography variant="body" sx={{color:"#313131"}}>{t("Orders to be Taken Today")}</Typography>
                      <Typography variant="h2">{todayOrders.length}</Typography>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item xs={12} sm={4} md={4}>
                <Card variant="outlined" sx={{ padding: 2, textAlign: "left" }}>
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="flex-start"
                    spacing={3}
                  >
                    
                    <Grid item>
                      <Typography variant="body" sx={{color:"#313131"}}>
                        {t("Orders to be Taken Tomorrow")}
                      </Typography>
                      <Typography variant="h2">{tomorrowOrders.length}</Typography>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item xs={12} sm={4} md={4}>
                <Card variant="outlined" sx={{ padding: 2, textAlign: "left" }}>
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="flex-start"
                    spacing={3}
                  >
                   
                    <Grid item>
                      <Typography variant="body" sx={{color:"#313131"}}>
                        {t("Today Orders to Deliver")}
                      </Typography>
                      <Typography variant="h2">{todayOrderstoDeliver.length}</Typography>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>

            <Grid
            container
            spacing={2}
            alignItems="center"
            mt={1}
            >
            <Grid item xs={12} sm={6} md={2}>
                <DatePicker
                label={t('From')}
                value={fromDate}
                onChange={(newValue) => setFromDate(newValue)}
                slotProps={{ textField: { fullWidth: true } }}
                inputFormat="dd/MM/yyyy"
                />
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
                <DatePicker
                label={t('To')}
                value={toDate}
                onChange={(newValue) => setToDate(newValue)}
                slotProps={{ textField: { fullWidth: true } }}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              
            </Grid>
           
            <Grid item xs={12} sm={12} md={4}>
                <TextField
                label={t('Search')}
                variant="outlined"
                onChange={(e) => setSearchQuery(e.target.value)}
                sx={{ float: 'right' }}
                fullWidth
                />
            </Grid>
            </Grid>
            <Grid>
            <Grid item xs={12} sm={12} md={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={showUncompletedOnly}
                  onChange={(e) => setShowUncompletedOnly(e.target.checked)}
                  color="primary"
                />
              }
              label={t('Show only Uncompleted Orders')}
              sx={{marginTop:'5px'}}
            />
          </Grid>
          </Grid>
            {showTableView && (
            <>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {t('Order ID')}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {t('Customer Name')}
                      </Typography>
                    </TableCell>
                    <TableCell>
                    <Typography variant="subtitle1" fontWeight="bold">
                        {t('Inscription')}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {t('Status')}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {t('Fulfillment Date')}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {t('Fulfillment Method')}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {t('Action')}
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {filteredData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((order) => {
                    // Convert Firebase Timestamp to JavaScript Date
                    const fulfillmentTime = order.fulfillmentTime;
                    const isOverdue = new Date() > fulfillmentTime && order.orderStatus!=='Completed';
                  //  console.log(fulfillmentTime);
                    return (
                      <React.Fragment key={order.id}>
                      {/* Main Table Row */}
                      <TableRow
                        onClick={() => handleOrderClick(order.id)}
                        sx={{
                        cursor: "pointer",
                        backgroundColor: isOverdue ? "#fcfbe5" : "inherit", // Highlight overdue orders
                        }}
                      >
                        <TableCell>{order.orderID}</TableCell>
                        <TableCell>{order.customerName} ({order.phoneNumber})</TableCell>
                        <TableCell>{order.inscription}</TableCell>
                        <TableCell>
                          <Chip
                            size="small"
                            {...getStatusChipProps(order.orderStatus)}
                            sx={{ fontWeight: 600 }}
                          />
                        </TableCell>
                        <TableCell>
                        {formatDate(order.fulfillmentDate)}
                        </TableCell>
                        <TableCell>{order.fulfillmentMethod}</TableCell>
                        <TableCell>
                        <IconButton
                          onClick={(event) => {
                            event.stopPropagation();
                            handleActionClick("complete", order);
                          }}
                          color="primary"
                        >
                          <CheckCircle />
                        </IconButton>
                        <IconButton
                          onClick={(event) => {
                            event.stopPropagation();
                            handleRefundClick(order.orderID, order.id);
                          }}
                          color="warning"
                        >
                          <CurrencyExchangeIcon />
                        </IconButton>
                        <IconButton
                          onClick={(event) => {
                            event.stopPropagation();
                            handleActionClick("details", order);
                          }}
                          color="secondary"
                        >
                          <Info />
                        </IconButton>
                        </TableCell>
                      </TableRow>

                      {/* Collapsed Detail Row */}
                      <TableRow>
                        <TableCell
                        style={{ paddingBottom: 0, paddingTop: 0, border: "none" }}
                        colSpan={7}
                        >
                        <Collapse
                          in={expandedOrderId === order.id}
                          timeout="auto"
                          unmountOnExit
                        >
                          {renderExpandedDetails(order)}
                        </Collapse>
                        </TableCell>
                      </TableRow>
                      </React.Fragment>
                    );
                  })}
              </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25,50]}
              component="div"
              count={filteredData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
            </>
            )}

            {!showTableView && (
              <Box sx={{ mt: 2 }}>
                <Grid container spacing={2}>
                  {filteredData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((order) => {
                      const isOverdue = new Date() > order.fulfillmentTime && order.orderStatus !== "Completed";

                      return (
                        <Grid item xs={12} key={order.id}>
                          <Card
                            sx={{
                              boxShadow: 2,
                              border: expandedOrderId === order.id ? `3px solid ${theme.palette.primary.main}` : "none",
                              transition: "all 0.3s ease",
                              backgroundColor: isOverdue ? "#fcfbe5" : "inherit",
                              '&:hover': {
                                boxShadow: 4,
                              },
                            }}
                          >
                            <CardContent
                              sx={{ pb: 1, cursor: "pointer" }}
                              onClick={() => handleOrderClick(order.id)}
                            >
                              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
                                <Box>
                                  <Typography variant="h6" sx={{ fontWeight: "bold", color: theme.palette.primary.main }}>
                                    Order #{order.orderID}
                                  </Typography>
                                  <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
                                    {order.customerName} ({order.phoneNumber})
                                  </Typography>
                                  <Typography variant="body2" color="textSecondary">
                                    Fulfillment: {formatDate(order.fulfillmentDate)}
                                  </Typography>
                                  <Typography variant="body2" color="textSecondary">
                                    Method: {order.fulfillmentMethod || "N/A"}
                                  </Typography>
                                </Box>
                                <Chip
                                  {...getStatusChipProps(order.orderStatus)}
                                  size="small"
                                  sx={{ fontWeight: 600 }}
                                  onClick={(event) => event.stopPropagation()}
                                />
                              </Box>

                              <Divider sx={{ my: 1.5 }} />

                              <Grid container spacing={1}>
                                <Grid item xs={6}>
                                  <Typography variant="caption" color="textSecondary" display="block">
                                    Balance
                                  </Typography>
                                  <Typography variant="body2" fontWeight={600}>
                                    {formatToMyanmarCurrency(order.remainingBalance || 0)} {t("MMK")}
                                  </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography variant="caption" color="textSecondary" display="block">
                                    Delivery Fee
                                  </Typography>
                                  <Typography variant="body2" fontWeight={600}>
                                    {formatToMyanmarCurrency(order.deliveryFeeAmount || 0)} {t("MMK")}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="caption" color="textSecondary" display="block">
                                    Inscription
                                  </Typography>
                                  <Typography variant="body2" sx={{ wordBreak: 'break-word' }}>
                                    {order.inscription || "No inscription"}
                                  </Typography>
                                </Grid>
                              </Grid>

                              <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
                                <IconButton
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    handleOrderClick(order.id);
                                  }}
                                  size="small"
                                  sx={{ color: theme.palette.primary.main }}
                                >
                                  {expandedOrderId === order.id ? <ExpandLess /> : <ExpandMore />}
                                </IconButton>
                              </Box>
                            </CardContent>

                            <Collapse in={expandedOrderId === order.id} timeout="auto" unmountOnExit>
                              <Divider />
                              <CardContent sx={{ pt: 2 }}>
                                {renderExpandedDetails(order)}
                              </CardContent>
                            </Collapse>

                            <Divider />
                            <CardActions sx={{ flexDirection: "column", gap: 1, px: 2, pb: 2, alignItems: "stretch" }}>
                              <Button
                                size="small"
                                startIcon={<CheckCircle />}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  handleActionClick("complete", order);
                                }}
                                variant="contained"
                                color="primary"
                                fullWidth
                              >
                                Complete
                              </Button>
                              <Button
                                size="small"
                                startIcon={<CurrencyExchangeIcon />}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  handleRefundClick(order.orderID, order.id);
                                }}
                                variant="outlined"
                                color="warning"
                                fullWidth
                              >
                                Refund
                              </Button>
                              <Button
                                size="small"
                                startIcon={<Info />}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  handleActionClick("details", order);
                                }}
                                variant="text"
                                color="secondary"
                                fullWidth
                              >
                                Details
                              </Button>
                            </CardActions>
                          </Card>
                        </Grid>
                      );
                    })}
                </Grid>

                <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25,50]}
                    component="div"
                    count={filteredData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Box>
              </Box>
            )}
          </Box>
        </LocalizationProvider>
         )}
      </Container>
      
      <Refund
              open={showRefundModal}
              onClose={handleRefundClose}
              order={selectedOrderForRefund}
      />
      <ReleaseOrderDialog
        confirmationOpen={confirmationOpen}
        handleConfirmationClose={handleConfirmationClose}
        confirmOrderId={confirmOrderId}
        selectedOrder={selectedOrderForDialog}
        orderCompleted={orderCompleted}
        balance={balance}
        formatToMyanmarCurrency={formatToMyanmarCurrency}
        splitPayments={splitPayments}
        handleSplitPaymentMethodChange={handleSplitPaymentMethodChange}
        handleSplitPaymentAmountChange={handleSplitPaymentAmountChange}
        addSplitPayment={addSplitPayment}
        removeSplitPayment={removeSplitPayment}
        balanceError={balanceError}
        handleCollectBalance={handleCollectBalance}
        isBalanceCollected={isBalanceCollected}
        collectBalanceLoading={collectBalanceLoading}
        handlePrint={handlePrint}
        deliveryFee={deliveryFee}
        deliveryPaymentMethod={deliveryPaymentMethod}
        setDeliveryPaymentMethod={setDeliveryPaymentMethod}
        handlePayDelivery={handlePayDelivery}
        isDeliveryPaid={isDeliveryPaid}
        payDeliveryLoading={payDeliveryLoading}
        handleCompleteOrder={handleCompleteOrder}
        completeOrderLoading={completeOrderLoading}
        selectedCashier={selectedCashier} // Pass selected cashier
        setSelectedCashier={setSelectedCashier} // Pass setter for cashier
      />
        {confirmOrderId&&(
         <BalanceReceipt
          ref={receiptRef}
          order={filteredData.find(order => order.id === confirmOrderId)} // Use document ID instead of orderID
          splitPayments={splitPayments}
          deliveryFee={deliveryFee}
          deliveryPaymentMethod={deliveryPaymentMethod}
        />
        )}
         <Snackbar
              open={snackbarOpen}
              autoHideDuration={6000}
              onClose={handleSnackbarClose}
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
              <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
                {snackbarMessage}
              </Alert>
            </Snackbar>

    </ThemeProvider>
    </Layout>
  );
};

export default ReleaseOrder;
